import http from '../http'

export async function fetchSystemBootstrap() {
    return await http.post('/system/bootstrap')
}

/** 读取当前后台账号在各业务列表上的字段视图偏好。 */
export async function fetchSystemTableViewPreferences() {
    return await http.post('/system/table-views/list')
}

/** 保存当前后台账号在一个业务列表上的字段视图偏好。 */
export async function saveSystemTableViewPreference(payload) {
    return await http.post('/system/table-views/save', payload)
}

/** 读取当前后台账号已经看过的使用指引版本。 */
export async function fetchSystemGuideProgress() {
    return await http.post('/system/guide-progress/list')
}

/** 幂等保存当前后台账号一个使用指引版本的状态。 */
export async function saveSystemGuideProgress(payload) {
    return await http.post('/system/guide-progress/save', payload)
}

// CRM 页面只需要负责人下拉选项，避免加载完整系统启动数据。
export async function fetchSystemSalesOwners() {
    return await http.post('/system/sales-owners/list')
}

// 项目与验收页面只需要项目经理下拉选项，避免从业务分页记录反推人员名单。
export async function fetchSystemProjectManagers() {
    return await http.post('/system/project-managers/list')
}

/** 查询售后问题反馈处理列表。 */
export async function fetchSystemFeedbackTicketPage(payload = {}) {
    return await http.post('/system/feedback-tickets/page', payload)
}

/** 写入售后处理回复，回复后由服务端更新为已回复。 */
export async function replySystemFeedbackTicket(payload) {
    return await http.post('/system/feedback-tickets/reply', payload)
}

/** 开始处理或关闭售后问题反馈。 */
export async function updateSystemFeedbackTicketStatus(payload) {
    return await http.post('/system/feedback-tickets/status', payload)
}

export async function fetchSystemAccountPage(payload = {}) {
    return await http.post('/system/accounts/page', payload)
}

export async function createSystemAccount(payload) {
    return await http.post('/system/accounts/save', payload)
}

export async function updateSystemAccount(id, payload) {
    return await http.post('/system/accounts/save', {...payload, id})
}

export async function updateSystemAccountStatus(id, enabled) {
    return await http.post('/system/accounts/update-status', {id, enabled})
}

/** 逻辑删除成员账号；后端会同步停用账号并清理全部后台会话。 */
export async function deleteSystemAccount(id) {
    return await http.post('/system/accounts/delete', {id})
}

/** 保存成员前预览其最终可见模块和数据范围。 */
export async function previewSystemAccountAuthorization(payload) {
    return await http.post('/system/accounts/authorization-preview', payload)
}

/** 查询限时授权的中文对象类型和可搜索业务对象。 */
export async function fetchSystemAuthorizationResources(payload = {}) {
    return await http.post('/system/accounts/authorization-resources', payload)
}

/** 生成一次性临时密码，并使成员下次登录强制改密。 */
export async function resetSystemAccountPassword(id) {
    return await http.post('/system/accounts/reset-password', {id})
}

/** 清理指定成员的全部后台会话。 */
export async function forceLogoutSystemAccount(id) {
    return await http.post('/system/accounts/force-logout', {id})
}

/** 启动固定30分钟的后台账号代入排障，不读取或传输目标账号密码。 */
export async function startSupportSession(payload) {
    return await http.post('/system/support-sessions/start', payload)
}

/** 主动退出当前账号代入排障，并由服务端恢复原超级管理员身份。 */
export async function stopSupportSession() {
    return await http.post('/system/support-sessions/stop')
}

/** 仅超级管理员可查询生产排障代入会话记录。 */
export async function fetchSupportSessionPage(payload = {}) {
    return await http.post('/system/support-sessions/page', payload)
}

/** 仅超级管理员可立即撤销仍有效的生产排障代入会话。 */
export async function revokeSupportSession(id) {
    return await http.post('/system/support-sessions/revoke', {id})
}

export async function fetchSystemAccountScopeExceptions(accountId) {
    return await http.post('/system/accounts/scope-exceptions/list', {id: accountId})
}

export async function createSystemAccountScopeException(accountId, payload) {
    return await http.post('/system/accounts/scope-exceptions/save', {...payload, accountId})
}

export async function updateSystemAccountScopeException(accountId, id, payload) {
    return await http.post('/system/accounts/scope-exceptions/save', {...payload, accountId, id})
}

export async function updateSystemAccountScopeExceptionStatus(accountId, id, enabled) {
    return await http.post('/system/accounts/scope-exceptions/update-status', {accountId, id, enabled})
}

export async function createSystemRole(payload) {
    return await http.post('/system/roles/save', payload)
}

export async function updateSystemRole(id, payload) {
    return await http.post('/system/roles/save', {...payload, id})
}

/** 获取按中文业务模块组织的权限目录。 */
export async function fetchSystemPermissionCatalog() {
    return await http.post('/system/permissions/catalog')
}

/** 从预设或已有角色复制一个自定义角色。 */
export async function copySystemRole(payload) {
    return await http.post('/system/roles/copy', payload)
}

/** 保存前预览角色的最终授权效果。 */
export async function previewSystemRole(payload) {
    return await http.post('/system/roles/preview', payload)
}

/** 启用或停用自定义角色。 */
export async function updateSystemRoleStatus(id, enabled) {
    return await http.post('/system/roles/update-status', {id, enabled})
}

export async function createSystemMenu(payload) {
    return await http.post('/system/menus/save', payload)
}

export async function updateSystemMenu(id, payload) {
    return await http.post('/system/menus/save', {...payload, id})
}

export async function createSystemDictionary(payload) {
    return await http.post('/system/dictionaries/save', payload)
}

export async function updateSystemDictionary(id, payload) {
    return await http.post('/system/dictionaries/save', {...payload, id})
}

export async function saveSystemConfigItems(payload) {
    return await http.post('/system/config-items/save', payload)
}

export async function fetchSystemResourceTypeTemplates() {
    return await http.post('/system/resource-type-templates/list')
}

export async function saveSystemResourceTypeTemplate(payload) {
    return await http.post('/system/resource-type-templates/save', payload)
}

export async function updateSystemResourceTypeTemplateStatus(id, enabled) {
    return await http.post('/system/resource-type-templates/update-status', {id, enabled})
}

export async function fetchSystemFlightTaskMilestoneTemplates() {
    return await http.post('/system/flight-task-milestone-templates/list')
}

export async function saveSystemFlightTaskMilestoneTemplate(payload) {
    return await http.post('/system/flight-task-milestone-templates/save', payload)
}

export async function updateSystemFlightTaskMilestoneTemplateStatus(id, enabled) {
    return await http.post('/system/flight-task-milestone-templates/update-status', {id, enabled})
}

export async function fetchSystemEnvironment() {
    return await http.post('/system/environment')
}

/** 分页查询固定事件通知模板。 */
export async function fetchSystemNoticeTemplatePage(payload = {}) {
    return await http.post('/system/notice-templates/page', payload)
}

/** 保存已有通知模板。 */
export async function saveSystemNoticeTemplate(payload) {
    return await http.post('/system/notice-templates/save', payload)
}

/** 更新通知模板启用状态。 */
export async function updateSystemNoticeTemplateStatus(id, enabled) {
    return await http.post('/system/notice-templates/update-status', {id, enabled})
}

/** 分页查询统一发送日志。 */
export async function fetchSystemNoticeLogPage(payload = {}) {
    return await http.post('/system/notice-logs/page', payload)
}

/** 人工重试失败或结果未知的通知。 */
export async function retrySystemNoticeLog(payload) {
    return await http.post('/system/notice-logs/retry', payload)
}

/** 查询通知通道是否就绪，不返回密钥。 */
export async function fetchSystemNoticeChannelStatus() {
    return await http.post('/system/notice-channels/status')
}

/** 分页查询当前后台账号的个人站内消息。 */
export async function fetchBackstageNoticePage(payload = {}) {
    return await http.post('/system/in-app-notices/page', payload)
}

/** 查询当前后台账号的站内消息未读数。 */
export async function fetchBackstageNoticeUnreadCount() {
    return await http.post('/system/in-app-notices/unread-count')
}

/** 标记当前后台账号的一条站内消息已读。 */
export async function readBackstageNotice(id) {
    return await http.post('/system/in-app-notices/read', {id})
}

/** 标记当前后台账号的全部站内消息已读。 */
export async function readAllBackstageNotices() {
    return await http.post('/system/in-app-notices/read-all')
}
